const DEV_FRONTEND_PORTS = new Set(['3000', '5173', '8080']);

export function deriveApiBaseUrl(): string {
  if (typeof window === 'undefined') {
    return '';
  }

  const explicit = import.meta.env.VITE_API_URL?.trim();
  if (explicit) {
    return explicit;
  }

  const url = new URL(window.location.origin);

  // Local dev (Windows VM or any machine on ports 3000/5173/8080) — redirect to :8000
  if (DEV_FRONTEND_PORTS.has(url.port)) {
    url.port = '8000';
    return url.toString().replace(/\/$/, '');
  }

  return window.location.origin;
}
